<!--  -->
<template>
  <div :class="{ tabs: true, tabsFixed: tabFixed }">
    <!-- tab标签 -->
    <div class="chapterTabs" v-if="isshow">
      <div
        v-for="(item, index) in tabsList"
        @click="cutTab(item.id)"
        :class="{ active: tabSelected == item.id, oneTab: tabsList.length === 1 }"
        :key="item.id"
        :style="{ flex: tabsList.length === 1 ? '' : 1 }"
      >
        <p>{{ item.name }}</p>
        <span></span>
      </div>
    </div>
    <!-- tab内容 -->
    <div class="tabContent">
      <CourseIntroduction v-show="introduction && tabSelected === 0" :introduction="introduction" />
      <CourseList v-show="tabSelected === 1" />
      <!-- (!introduction && tabSelected === 1) ||  -->
      <Teacher v-show="tabSelected === 2" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CourseList from './courseList.vue';
import CourseIntroduction from './courseIntroduction.vue';
import Teacher from './teacher.vue';

export default {
  components: {
    CourseList,
    Teacher,
    CourseIntroduction,
  },
  props: ['tabFixed'],
  computed: {
    ...mapState(['courseBaseData']),
  },
  data() {
    return {
      tabsList: [
        { id: 0, name: '课程介绍' },
        { id: 1, name: '包含课程' },
        { id: 2, name: '师资介绍' },
      ],
      tabSelected: 0,
      introduction: '',
      isshow: false,
    };
  },
  watch: {
    courseBaseData(data) {
      this.containsCourseLabel = data?.containsCourseLabel;
      if (+data?.containsCourseLabel !== 1) {
        this.tabsList = this.tabsList.filter((item) => item.name !== '包含课程');
      }
      // 判断取套餐本身的课程介绍，还是所选标签产品的课程介绍,introductionType和currentIntroductionId 非后端接口字段，是前端自定义;
      const packageIntroductData = data?.introductionType === 1 ? data?.packageIntroductionRespList : data?.allTagListData?.find(item=> item?.productId === data?.currentIntroductionId)?.productIntroductionRespVOList;
      this.introduction = packageIntroductData?.find(
        (ele) => ele.terminalType === 2,
      )?.introduction;
      if (this.introduction === '<p></p>') {
        this.introduction = '';
      }
      if (!this.introduction && data?.introductionType === 1) {
        this.tabsList.splice(0, 1);
        this.tabSelected = this.tabsList[0].id;
      } else {
        this.tabsList = [
          { id: 0, name: '课程介绍' },
          { id: 1, name: '包含课程' },
          { id: 2, name: '师资介绍' },
        ];
        this.tabSelected = this.tabsList[0].id;
      }
      this.isshow = true;
    },
  },
  mounted() {},
  methods: {
    // 切换tab
    cutTab(index) {
      this.tabSelected = index;
    },
  },
};
</script>

<style lang="scss" scoped>
$pubColor: #ff6c02;
$pubGrayColor: #787878;
.tbas {
  margin-top: 20px;
}
.chapterTabs {
  /* tabs label */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 94px;
  background: #fff;
  border-bottom: 2px solid rgba(120, 120, 120, 0.2);
  border-radius: 14px 14px 0 0;
  > div {
    position: relative;
    display: flex;
    // flex: 1;
    align-items: center;
    justify-content: center;
    width: 34%;
    height: 100%;
    background: #fff;

    p {
      width: 100%;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      text-align: center;
      border-right: 2px solid #edf1f6;
    }
  }
  .active {
    /* 被选中状态 */
    > p {
      color: $pubColor;
    }
    &::before {
      position: absolute;
      bottom: 0;
      width: 45px;
      height: 5px;
      background-color: $pubColor;
      border-radius: 10px 10px 0 0;
      content: ' ';
    }
  }
  > div:last-child {
    p {
      border: none;
    }
  }
  .oneTab {
    width: 34%;
  }
}
.tabContent {
  /* tab content */
  width: 100%;
  min-height: 30vh;
  padding-bottom: 180px;
  background: #fff;
}
.tabsFixed {
  .chapterTabs {
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .tabContent {
    margin-top: 94px;
  }
}
</style>
